import { timelineEvents } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const toneStyles: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

const chipStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function Timeline() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <SectionHeading
          id="timeline"
          kicker="03 / TIMELINE"
          title="塌房记录"
          desc="从最早的搬运争议，到最近的审核质疑，按年份摊开成一条时间线。事件之间未必有因果，但连起来看，轨迹会清晰很多。"
        />

        <ol className="relative mt-10 ml-3 border-l border-background-300 md:mt-14 md:ml-6">
          {timelineEvents.map((event) => (
            <li key={`${event.year}-${event.title}`} data-reveal className="relative pb-10 pl-8 last:pb-0 md:pl-12">
              <span
                className={`absolute -left-[7px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full ring-4 ring-background-50 ${
                  toneStyles[event.tone] ?? 'bg-foreground-400'
                }`}
              />
              <div className="flex flex-wrap items-center gap-3">
                <span className="font-display text-3xl leading-none text-foreground-950 md:text-4xl">
                  {event.year}
                </span>
                <span
                  className={`rounded-full px-3 py-1 text-xs ${
                    chipStyles[event.tone] ?? 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {event.title}
                </span>
              </div>
              <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
                {event.desc}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}